__turbopack_context__.v({
  "notifyModal": "ooz1Pa_notifyModal",
  "price-block": "ooz1Pa_price-block",
  "root": "ooz1Pa_root",
  "shipping": "ooz1Pa_shipping",
  "subtitle-text-btn": "ooz1Pa_subtitle-text-btn",
  "tax-disclaimer": "ooz1Pa_tax-disclaimer",
  "total-price-single": "ooz1Pa_total-price-single",
});
